<mat-tab-group mat-align-tabs="start" animationDuration="0"
               class="w-100 h-100 hide-scroll-bar"
               [(selectedIndex)]="selectedTabIndex">
    @for (tab of tabs; track tab) {
        <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
            <ng-template matTabContent>
                @if (tab === 'tabContactDetails') {
                    <af-contact-details-view-tab [contactDetails]="contactDetails" class="w-100"/>
                }
                @if (tab === 'tabMsisdnInfo') {
                    <af-contact-msisdn-info-tab [contactDetails]="contactDetails" class="w-100"/>
                }
                @if (tab === 'tabStatusHistory') {
                    <af-contact-status-history-tab [contactDetails]="contactDetails" class="w-100"/>
                }
                @if (tab === 'tabFiles') {
                    <af-contact-files-tab [contactDetails]="contactDetails" class="w-100"/>
                }
            </ng-template>
        </mat-tab>
    }
</mat-tab-group>
